<template>
  <div class="hello">
    <h1>快一點開店程式</h1>
    <p>[無webhook版本] [聊天模式(一對一)]要開新Provider, 新Channel, 新OA, <span style="color:#AA0000">新快一點的店</span>，前往<a href="#" @click="goTo('new-shop-chat')">這裏</a></p>
    <p>[無webhook版本] [機器人模式(自動顯示已讀)]要開新Provider, 新Channel, 新OA, <span style="color:#AA0000">新快一點的店</span>，前往<a href="#" @click="goTo('new-shop-bot')">這裏</a></p>
    <p>快一點的無OA 版本，前往<a href="#" @click="goTo('new-shop-no-oa')">這裏</a></p>
    <p>快一點的WEB 版本，前往<a href="#" @click="goTo('new-shop-web')">這裏</a></p>
    <p>要開新Provider, 新Channel, 新OA, <span style="color:#AA0000">新快一點的店</span>，前往<a href="#" @click="goTo('new-shop')">這裏</a></p>
    <p>快一點的店<span style="color:#AA0000">已存在</span>，要更新Provider, Channel, OA，前往<a href="#" @click="goTo('old-shop')">這裏</a></p>
    <p>快一點的店<span style="color:#AA0000">已存在</span>，先前已轉移過店家自己的OA，要將OA加入Provider，前往<a href="#" @click="goTo('old-shop-oa')">這裏</a></p>
    <p>快一點的零售店 OA 版本，前往<a href="#" @click="goTo('retail')">這裏</a></p>
    <p>快一點的零售店，不開OA，前往<a href="#" @click="goTo('retail-no-oa')">這裏</a></p>
  </div>
</template>

<script>

export default {
  name: 'Home',
  props: {
    msg: String
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
